import React, { useEffect, useState } from "react";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import InputIcon from "react-multi-date-picker/components/input_icon";
import DateObject from "react-date-object";

const PersianDataPickerNew = ({ form, field, operator, label, alsoOnchange, hasTime }) => {
  const [dateValue, setDateValue] = useState(null);

  useEffect(() => {
    if (!field.value) {
      setDateValue(null);
      return;
    }

    const parts = field.value.split("-");
    if (parts.length >= 3) {
      const isoDate = parts.slice(2).join("-");
      const dateObj = new DateObject({
        date: isoDate,
        calendar: persian,
        locale: persian_fa,
      });
      setDateValue(dateObj);
    }
  }, [field.value]);

  const handleChange = (value) => {
    const isoDate = value?.toDate().toISOString();
    form.setFieldValue(field.name, `createdAt-${operator}-${isoDate}`);

    if (alsoOnchange) alsoOnchange(isoDate);
    setDateValue(value);
  };

  return (
    <div style={{ position: "relative", zIndex: 9999999999 }}>
      <label className="block uppercase text-blueGray-600 dark:text-gray-300 text-xs font-bold mb-2">
        {label}
      </label>
      <div style={{ direction: "ltr", position: "relative", zIndex: 99999999999 }}>
        <DatePicker
          key={field.name} 
          value={dateValue}
          onChange={handleChange}
          format="YYYY/MM/DD"
          calendar={persian}
          locale={persian_fa}
          calendarPosition="bottom-right"
          plugins={hasTime ? [<TimePicker position="left" />] : []}
          render={<InputIcon />}
          inputClass="custom-input"
          inputStyle={{
            textAlign: "center",
            fontFamily: "Tahoma, Arial",
            direction: "rtl",
          }}
        />
      </div>
    </div>
  );
};

export default PersianDataPickerNew;
